<template>
  <div class="download-page" v-title data-title="卓考网校官网|救命稻草APP下载">
    <header class="g-header-container">
      <c-header title="救命稻草APP下载" />
    </header>
    <main class="g-view-container">
      <c-slider>
        <template v-for="(item, index) in details">
          <swiper-slide :key="index">
            <img class="detail" :src="item" />
          </swiper-slide>
        </template>
      </c-slider>
      <div class="content">
        <h2 class="title">救命稻草APP，每道题都是精华</h2>
        <div class="btn-download" @click="download">点击下载APP</div>
      </div>

      <div class="footer">
        <a href="javascript:void(0);" class="link">不止是课程，更是一次考过计划！</a>
        <p class="text">Copyright © 2016-2020 zhuokao360.com</p>
      </div>
    </main>
  </div>
</template>

<script>
  import CHeader from 'components/header';
  import CSlider from 'base/slider';
  import judgeClient from 'assets/js/judgeClient';
  import { jmdc } from '../config';

  export default {
    name: 'jmdcDownload',
    components: {
      CHeader,
      CSlider,
    },
    created() {
      this.details = jmdc.detail;
    },
    methods: {
      download() {
        const ua = judgeClient();
        if (ua === 'Android') {
          window.location.href = jmdc.androidUrl;
        } else if (ua === 'iOS') {
          window.location.href = jmdc.iosUrl;
        } else {
          this.$toast('请用手机打开');
        }
      },
    },
  };
</script>

<style lang="scss" scoped>
@import "~assets/scss/mixins";

.g-view-container {
  position: relative;
  padding-bottom: 16px;
  @include flex-between(column);
}

.swiper-container {
  width: 100%;

  .detail {
    width: 100%;
  }

  ::v-deep .swiper-pagination {
    bottom: -1px;
  }
}

.content {
  margin-top: 10px;
  width: 100%;
  flex: 1;

  .title {
    font-size: 14px;
    color: #333;
    text-align: center;
    line-height: 3;
  }

  .btn-download {
    margin: 0 auto;
    width: 90%;
    height: 40px;
    line-height: 40px;
    font-size: 14px;
    letter-spacing: 1px;
    color: #fff;
    text-align: center;
    background-color: #fe563e;
    border-radius: 4px;
  }
}

.footer {
  text-align: center;
  line-height: 1.75;

  .link {
    color: #576b95;
  }

  .text {
    color: rgba(0, 0, 0, 0.3);
  }
}
</style>
